<template>
  <div>
    <p class="condition-label text-label">{{ $t('tour_departure_time_condition') }}</p>
    <input :value="date" @change="onChange($event.target.value)" type="datetime-local" class="text-link is-condition">
  </div>
</template>

<script>
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  props: {
    value: {
      type: Object,
      default: function () {
        return moment('2020-09-24 09:30')
      }
    }
  },
  computed: {
    date: function () {
      return this.value.format(moment.HTML5_FMT.DATETIME_LOCAL)
    }
  },
  methods: {
    onChange: function (value) {
      this.$emit('input', moment(value))
    }
  }
}
</script>
